let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eLoti")).then(() => parcelRequire('5n11j'));